'use strict';

var Inflections = require('../var/Inflections');

function getAcronym(str) {
  return Inflections.acronyms && Inflections.acronyms.find(str);
}

module.exports = getAcronym;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/internal/getAcronym.js
// module id = 301
// module chunks = 1